
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useState } from 'react'
// import "./CSS/Feedback.css"
import "../sass/Feedback.scss"
import { BsChatTextFill } from 'react-icons/bs';
import { AiOutlineCloseCircle } from "react-icons/ai";
import Select from 'react-select';
import { isMobile } from 'react-device-detect';
import { CityContext } from './context/CityContext';
import { SelectedDataSet } from './context/SelectedDataset';
import { DateContext } from './context/DateContext';
import { toast } from 'react-toastify';
const Feedback = () => {
    const [open, setOPen] = useState(false);
    const { city } = useContext(CityContext);
    const { selectedDatasetName } = useContext(SelectedDataSet);
    const { date } = useContext(DateContext);
    const { getCity } = useContext(CityContext);
    const [commentLength, setCommentLength] = useState(false);
    const cityLocal = JSON.parse(localStorage.getItem("city"));
    const [selectedOption, setSelectedOption] = useState(null);
    const [feedbackForm, setFeedbackForm] = useState({
        options: "",
        comment: "",
        email: "",
        city: city,
        datasetName: selectedDatasetName ? selectedDatasetName : "",
        date: date
    })
    const notify = (msg) => toast.success(msg, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
    });
    const notifyerr = (msg) => toast.error(msg, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
    });
    useEffect(() => {

    }, [open])
    useEffect(() => {
        if (cityLocal != null) {
            getCity(cityLocal.locationURL);
        }
    }, [cityLocal, getCity]);
    useEffect(() => {
        if (feedbackForm.comment.length >= 500) {
            setCommentLength(true);
        }
        else {
            setCommentLength(false);
        }
    }, [feedbackForm.comment.length]);
    const optionss = [
        { value: 'Datsets', label: 'Datsets' },
        { value: 'UI', label: 'UI' },
        { value: 'Locations', label: 'Locations' },
        { value: "Graph", label: "Graph" },
        { value: 'Other', label: "Other" },
    ];

    const handleChange = (e) => {
        setFeedbackForm({
            ...feedbackForm,
            [e.target.name]: e.target.value
        })

    }
    const submitFeedback = (e) => {
        e.preventDefault();
        // console.log(feedbackForm);
        setSelectedOption(null);
        setFeedbackForm({
            options: "",
            comment: "",
            email: "",
            city: city,
            datasetName: selectedDatasetName ? selectedDatasetName : "",
            date: date
        })
        setOPen(false);
        addFeedBack(feedbackForm);
    }
    async function addFeedBack(form) {
        var myHeaders = new Headers();

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(form),
            redirect: 'follow',
            mode: 'cors'
        };

        fetch("https://skyserve.ai/earthsights_feed.php", requestOptions)
            .then((response) => {
                
                response.text();
                if (response.status === 201) {
                    notify("Feedback sent successfully");
                }
                else {
                    notifyerr("Something went wrong, please try again");
                }
                // console.log(response);
            })
            .catch(error => console.log('Feedback Submit Error'));

        // Check result http status code
        // Success status code will be 201
    }
    useEffect(() => {
        setFeedbackForm({
            options: "",
            comment: "",
            email: "",
            city: city,
            datasetName: selectedDatasetName ? selectedDatasetName : "",
            date: date
        })
        setSelectedOption(null);
    }, [city, date, selectedDatasetName])
    return (
        <div className={`${!isMobile ? 'feedback' : 'feedback-mob'}`}>
            <div className='feedback-container'>
                <div className={`${open == false ? 'feedback-open' : 'feedback-close'}`}>
                    <BsChatTextFill style={{
                        transform:"scaleX(-1)"
                    }} onClick={() => {
                        setOPen(true);
                    }} />
                    <p className='feedback-text'>Give us your feedback</p>
                </div>

                <div className={`${open == true ? 'form feedback-box-open' : 'form feedback-box-close'}`}>
                    {/* <IoClose/> */}
                    <AiOutlineCloseCircle className='close-icon' onClick={() => {
                        setOPen(false);
                    }} />
                    <form onSubmit={(e) => {
                        submitFeedback(e);
                    }}>
                        <div>Your Feedback is Appreciated</div>
                        <div className='small-font'>Send us any comment,feedback,suggestion, or problem you have encountered on our website so we can fix it right away</div>
                        <Select
                            required
                            name='options'
                            placeholder='Select Category'
                            className='select-tag'
                            defaultValue={selectedOption}
                            value={selectedOption}
                            onChange={(e) => {
                                setSelectedOption(e);
                                //   console.log(e);
                                //   handleChange(e);
                                setFeedbackForm({
                                    ...feedbackForm,
                                    options: e.value
                                })
                            }}
                            options={optionss}
                        />
                        <textarea required value={feedbackForm.comment} onChange={(e) => { handleChange(e) }} name="comment" className='comment-box' placeholder='Add your comments' rows="4" cols="50" maxLength="500" />
                        <div style={{ color: "red", fontSize: "10px", marginBottom:"0%",height:"15px" }}>{commentLength && "comment characters must not more than 500"}</div>
                        <input required value={feedbackForm.email} onChange={(e) => { handleChange(e) }} name="email" placeholder='Add your email' type="email" />
                        <button className='feedback-btn' type="submit">Submit</button>
                    </form>
                </div>
                {/* <button className='feedback-open'>Give us feedback</button> */}
            </div>
        </div>
    )
}

export default Feedback